import API_URLS from '@Constants/apiUrls.constants';
import {
  LoginRequest,
  LoginResponse,
  ValidateAccessTokenResponse,
} from '@Typings/auth.types';

import { baseApi } from './baseApi.service';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: API_URLS.AUTH.LOGIN,
        method: 'POST',
        body: credentials,
      }),
    }),
    validateAccessToken: builder.mutation<
      ValidateAccessTokenResponse,
      string | null
    >({
      query: (accessToken) => ({
        url: API_URLS.AUTH.VALIDATE_ACCESS_TOKEN,
        method: 'POST',
        body: {
          accessToken,
        },
      }),
    }),
    getNewAccessToken: builder.mutation<LoginResponse, string | null>({
      query: (refreshToken) => ({
        url: API_URLS.AUTH.GET_NEW_ACCESS_TOKEN,
        method: 'POST',
        body: {
          refreshToken,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export const {
  useLoginMutation,
  useValidateAccessTokenMutation,
  useGetNewAccessTokenMutation,
} = authApi;
